<p class="p3 fw-semibold c-t-blue-900 ots-staff-column__title">{{ title }}</p>
<div class="ots-list d-flex flex-direction-column gap-12">
  @for (card of cards; track card.id) {
    <ots-staff-order-card [card]="card" (advanceStatus)="advanceStatus.emit(card.id)" />
  }
</div>
